import React, { useState, useEffect } from "react";
import "../../assets/styles/admin/quotation.scss";
import { Table, TableColumn } from "../../components/table";
import Icon from "@mdi/react";
import { mdiMinusCircle, mdiAlertCircleOutline } from "@mdi/js";
import { useHistory } from "react-router-dom";
import HeaderBar from "../../components/header/headerBar";
import Counter from "../../components/counter/counter";
import MainButton from "../../components/button/mainButton";
import EmptyModel from "../../components/modal/emptyModal";
import { Input } from "../../components/textfield";
import SelectField from "../../components/select/selectField";
import { InputNumber, message } from "antd";
import NumberFormat from "react-number-format";
import { numberWithCommas } from "../../helpers/functions";
import axios from "axios";
import styled from 'styled-components'
interface Props {
  ChangItem: (item: any) => void;
  ChangStep: (number: number) => void;
  onClose?: () => void;
  onSubmit?: () => void;
  Item?: any;
  other: string;
  userData?: object | any;
}

const QuotationCreateStep2: React.FC<Props> = ({
  ChangItem,
  ChangStep,
  Item,
  other,
  userData,
}) => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [textModal, setTextModal] = useState<number | string>("");
  const [itemModal, setItemModal] = useState<any>({});

  const [errors, setErrors] = useState<boolean>(false);
  const [selectAesthetic, setSelectAesthetic] = useState<any>(Item);
  const [sale, setSale] = useState(JSON.parse(userData.sale));
  const [confirmID, setConfirmID] = useState<string>("");
  const [note, setNote] = useState<string>("");
  const columns = [
    {
      title: "รหัส<br/>Code No.",
      align: "center",
      rowspan: 2,
    },
    {
      title: "รายการ<br/>List",
      align: "center",
      rowspan: 2,
    },
    {
      title: "ราคา<br/>Price",
      align: "center",
      rowspan: 2,
    },
    {
      title: "จำนวน<br/>Quantity",
      align: "center",
      rowspan: 2,
    },
    {
      title: "รวม<br/>Total",
      align: "center",
      rowspan: 2,
    },
    {
      title: "คอมมิชชั่น<br/>Commission",
      align: "center",
      colspan: 2,
      rowspan: 1,
    },
    {
      title: "ราคาพิเศษ<br/>Special Price",
      align: "center",
      rowspan: 2,
    },
    {
      title: "ราคารวม<br/>Total Price",
      align: "center",
      rowspan: 2,
    },
    {
      title: "ความเห็น<br/>Remark",
      align: "center",
      rowspan: 2,
    },
  ];
  const columnsPromotion = [
    {
      title: "รหัส<br/>Code No.",
      align: "center",
      rowspan: 2,
    },
    {
      title: "รายการ<br/>List",
      align: "center",
      rowspan: 2,
    },
    {
      title: "ราคา/หน่วย<br/>Price/Unit",
      align: "center",
      rowspan: 2,
    },
    {
      title: "จำนวน<br/>Quantity",
      align: "center",
      rowspan: 2,
    },
    {
      title: "รวม<br/>Total",
      align: "center",
      rowspan: 2,
    },
    {
      title: "คอมมิชชั่น<br/>Commission",
      align: "center",
      colspan: 2,
      rowspan: 1,
    },
    {
      title: "ส่วนลด/Discount",
      align: "center",
      rowspan: 2,
    },
    {
      title: "Total Price",
      align: "center",
      rowspan: 2,
    },
    {
      title: "ความเห็น<br/>Remark",
      align: "center",
      rowspan: 2,
    },
  ];
  const subHeader = [
    {
      title: "พนักงานขาย<br/>Sales",
      align: "center",
    },
    {
      title: "แพทย์<br/>Doctor",
      align: "center",
    },
  ];

  const onConfirm = () => {
    let mockData = {
      customer: userData?.customer,
      sale: JSON.parse(userData?.sale),
      date: userData?.date.format(),
      categories: userData?.categories,
      purchaseType: userData?.purchaseType,
      treatments: Item,
      note
    }
    console.log(mockData)
    axios
      .post(`/quotation`, mockData)
      .then((res) => {
        if (res.status === 200) {
          setConfirmID(res?.data?._id);
          setConfirm(true);
          onClose();
        }
      });
  };
  const onRemove = () => {
    selectAesthetic.splice(textModal, 1);
    ChangItem([...selectAesthetic]);
    setSelectAesthetic([...selectAesthetic]);
    onClose();
  };
  function onClose() {
    setIsOpen(false);
    setErrors(false);
    setIsOpenConfirm(false);
  }
  const ChangRender = styled.div``
  return (
    <div>
      <HeaderBar title="QUOTATION" onClick={() => ChangStep(1)} />
      <div style={{ padding: "10px 30px" }}>
        <EmptyModel show={isOpen} onClose={onClose} setStyle={{height : 'auto'}}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              height: "300px",
              paddingTop: "20px",
            }}
          >
            <Icon path={mdiAlertCircleOutline} size="80" color="#E76464" />
            <div className="col-12" style={{ textAlign: "center" }}>
              ต้องการลบรายการ {itemModal.name}/{itemModal?.quantity}{" "}
              {itemModal?.treatmentUnit !== null
                ? itemModal?.treatmentUnit
                : ""}{" "}
              ครั้งออกหรือไม่?
            </div>
            <div className="col-12" style={{ textAlign: "center" }}>
              Want to remove an {itemModal.name}/{itemModal?.quantity}{" "}
              {itemModal?.treatmentUnit !== null
                ? itemModal?.treatmentUnit
                : ""}{" "}
              from list?
            </div>
            <div className="justify-center">
              <MainButton
                className="mg-10"
                width="100px"
                title="ยกเลิก"
                background="#E76464"
                onClick={onClose}
              />

              <MainButton
                className="mg-10"
                width="100px"
                title="ตกลง"
                onClick={() => onRemove()}
              />
            </div>
          </div>
        </EmptyModel>
        <EmptyModel show={isOpenConfirm} onClose={onClose} setStyle={{
          height: 'auto'
        }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              height: "300px",
              paddingTop: "20px",
            }}
          >
            <Icon path={mdiAlertCircleOutline} size="80" color="#E76464" />
            <div className="col-12" style={{ textAlign: "center" }}>
              คุณต้องการยืนยันทำรายการหรือไม่ ?
            </div>
            <div className="justify-center">
              <MainButton
                className="mg-10"
                width="100px"
                title="ยกเลิก"
                background="#E76464"
                onClick={onClose}
              />

              <MainButton
                className="mg-10"
                width="100px"
                title="ตกลง"
                onClick={() => onConfirm()}
              />
            </div>
          </div>
        </EmptyModel>
        {confirm && (
          <div
            className="create-page"
            style={{
              marginBottom: "40px",
            }}
          >
            <div className="row space-between">
              <div className="col-4">
                <Input title="Customer" value={userData.customer} disabled />
              </div>
              <div className="col-4">
                <div className="select-field col-12">
                  <Input title="SALE" value={sale.displayName} disabled />
                </div>
              </div>
              <div className="col-4">
                <Input
                  title="DATE"
                  type="date"
                  value={userData.date}
                  disabled
                />
              </div>
            </div>
            <div className="row space-between"></div>
          </div>
        )}

        <Table
          header={other == "normal" ? columns : columnsPromotion}
          subHeader={subHeader}
        >
          {selectAesthetic.map((item: any, index: number) => (
            <tr key={index}>
              <TableColumn width="15%" align="center">
                <div className="row">
                  {!confirm && (
                    <div
                      className="col-2"
                      style={{ textAlign: "center", cursor: "pointer" }}
                      onClick={() => {
                        setIsOpen(true);
                        setTextModal(index);
                        setItemModal(item);
                      }}
                    >
                      <Icon path={mdiMinusCircle} size="20" color="#E76464" />
                    </div>
                  )}

                  <div className="col-4">{item.code}</div>
                </div>
              </TableColumn>
              <TableColumn width="25%">{item.name}</TableColumn>
              <TableColumn width="8%" align="center">
                <NumberFormat
                  value={(Math.round(Number(item.price) * 100) / 100).toFixed(
                    2
                  )}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </TableColumn>
              <TableColumn width="8%" align="center">
                <Counter
                fixed={false}
                  defaultValue={item.quantity}
                  length={1}
                  changeValue={(value) => {
                    item.quantity = value;
                    ChangItem([...selectAesthetic]);
                  }}
                  disabled={confirm}
                />
              </TableColumn>
              <TableColumn width="5%" align="center">
                <NumberFormat
                  value={(
                    Math.round(Number(item.price) * 100 * item.quantity) / 100
                  ).toFixed(2)}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </TableColumn>
              {other == "course" ? (
                <TableColumn width="8%" align="center">
                  {item.number}
                </TableColumn>
              ) : (
                ""
              )}
              <TableColumn width="8%" align="center">
                {item.commission.sales === true ? "ได้" : "ไม่ได้"}
              </TableColumn>
              <TableColumn width="8%" align="center">
                {item.commission.doctor === true ? "ได้" : "ไม่ได้"}
              </TableColumn>
              <TableColumn width="8%" align="center">
                <ChangRender>
                <Input
                  onChange={(e: any) => {
                    let total =  Number(item.price) * item.quantity;
                    let price = e.target.value - 0
                    console.log(total)
                    if(total >= price){
                      item.discount = price;
                      ChangItem([...selectAesthetic]);
                      console.log("update")
                    }else{
                      message.warning('ไม่สามารถใส่ส่วนลดเกินจำนวนราคารวมได้!');
                    }

                  }}
                  type="number"
                  disabled={confirm}
                  value={item.discount}
                />
                </ChangRender>
              </TableColumn>
              <TableColumn width="8%" align="center">
                <NumberFormat
                  value={Math.round(
                    Number(item.price) * item.quantity - item.discount
                  ).toFixed(2)}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </TableColumn>
              <TableColumn width="15%" align="center">
                <textarea
                  name="remark"
                  id="ins_remark"
                  cols={40}
                  rows={3}
                  className="textAraeWapper"
                  onChange={(e) => {
                    item.remark = e.target.value;
                    ChangItem([...selectAesthetic]);
                  }}
                  disabled={confirm}
                ></textarea>
              </TableColumn>
            </tr>
          ))}
        </Table>
      </div>
      <div style={{ marginTop: "20px", padding: "20px 20px" }}>
        <div className="container overflow-hidden">
          <div className="row gx-5">
            <div className="col">
              <div className="row p-3 border bg-light">
                <div className="col-12">
                  <div className="">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        lineHeight: "18px",
                      }}
                    >
                      หมายเหตุ/Note
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <textarea
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      minHeight: "100px",
                    }}
                    name="note"
                    className="textAraeWapper"
                    disabled={confirm}
                    onChange={(e) => setNote(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="p-3 border" style={{ background: "#E76464" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ color: "white" }}>
                    ยอดเงินส่วนลดทั้งหมด/Total discount amount
                  </span>
                  <div
                    style={{
                      display: "flex",
                      fontWeight: "bolder",
                      color: "white",
                    }}
                  >
                    {
                      <NumberFormat
                        value={Item.reduce((total: number, item: any) => {
                          return total + Math.round(item.discount);
                        }, 0)}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                    }
                  </div>
                </div>
              </div>
              <div className="p-3 border bg-light">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ color: "black" }}>
                    ยอดเงินหลังหักส่วนลดทั้งหมด/Balance after all discounts
                  </span>
                  <div
                    style={{
                      display: "flex",
                      fontWeight: "bolder",
                      color: "black",
                    }}
                  >
                    {
                      <NumberFormat
                        value={Item.reduce((total: number, item: any) => {
                          return (
                            total +
                            Math.round(
                              item.price * item.quantity - item.discount
                            )
                          );
                        }, 0)}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {confirm ? (
          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              background="#E76464"
              title="ย้อนกลับ/Go Back"
              onClick={() => history.goBack()}
            />
            <MainButton
              background="#4285F4"
              className="mg-10"
              onClick={() =>
                history.push(`/quotation/detail/${confirmID}/print`)
              }
              title="Print"
            />
          </div>
        ) : (
          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              background="#5BAEA9"
              title="เลือกซื้อต่อ / Continue Selection"
              onClick={() => ChangStep(1)}
            />
            <MainButton
              className="mg-10"
              title="ยืนยันรายการ"
              onClick={() => setIsOpenConfirm(true)}
            // onClick={() => history.push(`/quotation/detail/ADIS0701`)}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default QuotationCreateStep2;
